module.exports = __webpack_public_path__ + "static/investments-wrapper-465d394ea677545f8141bfa9a5913212.jpg";